import RulesLevelChip from './RulesLevelChip';

export default RulesLevelChip;
